module.exports = __webpack_public_path__ + "static/media/05-thumbnail.68d8d949.jpg";